import get from 'lodash/get';
import {createSelector} from 'reselect';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import first from 'lodash/first';
import filter from 'lodash/filter';
import {SITE_INSPECTION_STATUS} from '../../../models/enums'

/****************** SEARCH ******************/
export const getInspectionSearch = (state) => get(state, ['vegetation', 'inspection', 'search']);
export const getInspections = (state) => get(getInspectionSearch(state), ['results']);
export const getSearchSite = (state) => get(getInspectionSearch(state), ['site']);
export const isLoadingInspections = (state) => get(getInspectionSearch(state), ['loading']);
export const getInspectionAddressId = (state) => get(getInspectionSearch(state), ['addressId']);
export const getInspectionAddress = (state) => get(getInspectionSearch(state), ['address']);

/****************** CURRENT ******************/
export const getCurrent = (state) => get(state, ['vegetation', 'inspection', 'current']);
export const isLoadingInspection = (state) => get(getCurrent(state), ['loading']);
export const getInspection = (state) => get(getCurrent(state), ['inspection']);
export const getCurrentSite = (state) => get(getCurrent(state), ['site']);
export const isCopyingWrongVisit = (state) => get(state, ['vegetation', 'inspection', 'copyingWrongVisit'])

export const getInspectionById = (state, id) => {
    const inspection = getInspection(state);
    if(!inspection || inspection.id !== id) return null;
    return inspection;
};
export const getSiteById = (state, id) => {
    // When on Inspection page, get from inspection
    const inspection = getInspectionById(state, id);
    if (!inspection) return null;
    let inspectionSite = getCurrentSite(state);
    if (inspectionSite != null) {
        return inspectionSite;
    }
    // When on search page get from search results
    const inspections = getInspections(state);
    if (inspections.find(a => a.id === id)) {
        var site = getSearchSite(state);
        if (site != null) {
            return site;
        }
    }
    return null;
};

export const getInspectionHistory = createSelector(getInspection, (inspection) => {
    if(!inspection) return [];
    var history = [
        ...map(get(inspection, ['visits']), x => ({...x, category: 'Visit'})),
        ...map(get(inspection, ['notes']), x => ({...x, category: 'Note'})),
        ...map(get(inspection, ['notifications']), x => ({...x, category: 'Notification'})),
    ].map(x => ({
        id: x.id,
        category: x.category,
        type: x.type,
        date: x.start_date || x.created_date,
        created_by_name: x.created_by_name,
        create_date: x.created_date,
        incident: x.incident,
        link: x.file_url,
        text: x.text,
    }));

    return orderBy(history, ['date', 'create_date'], ['desc', 'desc']);
});

export const getOpenInspection = createSelector(getInspections, (inspections) => {
    if(!inspections) return null;
    return first(filter(inspections, x => x.status !== SITE_INSPECTION_STATUS.Closed))
});





// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/inspection.js